import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sprite-svg',
  templateUrl: './sprite-svg.component.html',
})

export class SpriteSvgComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
